"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Actions = void 0;
var Actions;
(function (Actions) {
    // Main booking flow events, both platforms, in chronological order
    Actions["SelectVertical"] = "select_vertical_v2";
    Actions["SelectSpeciality"] = "select_speciality_v2";
    Actions["SelectLocation"] = "select_location_v2";
    Actions["SelectClinic"] = "select_clinic_v2";
    Actions["SelectPractitioner"] = "select_practitioner_v2";
    Actions["SkipSelectPractitioner"] = "skip_select_practitioner_v2";
    Actions["OpenPractitionerInfo"] = "open_practitioner_info";
    Actions["OpenMap"] = "open_map_v2";
    Actions["SelectTime"] = "select_time_v2";
    Actions["Permissions"] = "permissions_v2";
    Actions["SelectPersonalDetails"] = "select_personal_details_v2";
    Actions["Confirm"] = "confirm_booking_v2";
    Actions["CompletedBooking"] = "completed_booking_v2";
    Actions["ClickedBookAgain"] = "clicked_book_again_v2";
    // Other booking related events, both platforms
    Actions["SelectDateButtonDisabled"] = "select_date_button_disabled";
    // Other booking related events, web only
    Actions["ClickAppStore"] = "click_app_store";
    Actions["ClickPlayStore"] = "click_play_store";
    Actions["ClickNextAvailable"] = "click_next_available";
    // Other booking related events, app only
    Actions["ExitFlow"] = "exit_flow_v2";
    Actions["GoBack"] = "go_back_v2";
    Actions["AddPartner"] = "add_partner_v2";
    Actions["BookAppointmentError"] = "book_appointment_error_v2";
    Actions["ClinicSortOptionClicked"] = "option_clicked_v2";
    Actions["CountryCodeTrimmed"] = "country_code_trimmed";
    Actions["CountryCodePicked"] = "country_code_picked_v2";
    Actions["CountryCodePressed"] = "country_code_pressed_v2";
    Actions["DeleteCard"] = "delete_card_v2";
    // Membership selection, app only
    Actions["SelectAgreementClicked"] = "select_agreement_clicked";
    Actions["SelectAgreementSuccess"] = "select_agreement_success";
    Actions["WithoutAgreementClicked"] = "without_agreement_clicked";
    Actions["ChangeAgreementClicked"] = "change_agreement_clicked";
    Actions["ModalChangeAgreementClicked"] = "modal_change_agreement_clicked";
    Actions["ModalWithoutAgreementClicked"] = "modal_without_agreement_clicked";
    Actions["ModalCancelAppointmentClicked"] = "modal_cancel_appointment_clicked";
    // Country selection for memberships, app only
    Actions["SelectCountryClicked"] = "select_country_clicked";
    Actions["SearchCountryClicked"] = "search_country_clicked";
    Actions["SelectCountrySuccess"] = "select_country_success";
    Actions["SelectCountryInvalid"] = "select_country_invalid";
    Actions["ChangeCountryClicked"] = "change_country_clicked";
    // Payment in app
    Actions["InitializePayment"] = "initialize_payment_v2";
    Actions["InitializedPayment"] = "initialized_payment_v2";
    Actions["InitializePaymentError"] = "initialize_payment_error_v2";
    Actions["PaymentCompleted"] = "payment_completed_v2";
    Actions["PaymentError"] = "payment_error_v2";
    Actions["VippsRedirectInitialized"] = "vipps_redirect_initialized_v2";
    Actions["VippsRedirectFailed"] = "vipps_redirect_failed_v2";
    Actions["VippsPaymentCancelled"] = "vipps_payment_cancelled_v2";
    Actions["VippsPaymentCompleted"] = "vipps_payment_completed_v2";
    Actions["UpdateUserPhone"] = "update_user_phone_v2";
    Actions["VideoInfoClicked"] = "video_info_clicked_v2";
    // APP
    // ----------------------------------------
    // Posthog
    Actions["CreateMembershipError"] = "create_membership_error";
    // Firebase analytics
    // Home-screens
    Actions["HomeAddPartners"] = "home_insurance&discount_add";
    Actions["HomeAddPartnersSelected"] = "home_insurance&discount_add_selected";
    Actions["HomeAddPartnersSelectedAdded"] = "home_insurance&discount_add_selected_added";
    Actions["HomeAddPartnersSelectedError"] = "home_insurance&discount_add_selected_error";
    Actions["HomeAddPartnersSelectedRequest"] = "home_insurance&discount_add_selected_request";
    Actions["HomeContact"] = "home_contact";
    Actions["HomeOnboarding"] = "home_onboarding";
    Actions["HomePartnersExisting"] = "home_insurance&discount_existing";
    Actions["HomePartnersExistingError"] = "home_insurance&discount_existing_error";
    Actions["HomePartnersExistingRemove"] = "home_insurance&discount_existing_remove";
    Actions["HomePartnersExistingRequestUpdate"] = "home_insurance&discount_existing_request_update";
    Actions["HomePartnersExistingUpdated"] = "home_insurance&discount_existing_updated";
    Actions["HomeReturn"] = "home_return";
    Actions["HomeScreen"] = "home_screen";
    Actions["HomeVideoHelp"] = "home_video_help";
    // New app update available notification
    Actions["UpdateAppShown"] = "update_app_shown";
    Actions["UpdateAppPressed"] = "update_app_pressed";
    // Expired membership modal
    Actions["ExpiredMembershipRemoved"] = "expired_membership_removed";
    Actions["ExpiredMembershipRenewed"] = "expired_membership_renewed";
    // Login flow
    Actions["LoginButtonPressed"] = "login_button_pressed";
    Actions["LoginCancelButtonPressed"] = "login_cancel_button_pressed";
    Actions["LoginCompleted"] = "login_completed";
    Actions["LoginError"] = "login_error";
    Actions["LoginFinished"] = "login_finished";
    Actions["LoginSetPinCode"] = "login_setting_pin_code";
    // Logout flow
    Actions["LogoutCompleted"] = "logout_completed";
    Actions["LogoutError"] = "logout_error";
    Actions["LogoutInitiated"] = "logout_initiated";
    Actions["LogoutProceed"] = "logout_proceed";
    Actions["LogoutPromptAnswered"] = "logout_prompt_answered";
    // ExorLive
    Actions["ClickExorLive"] = "click_exor_live";
    Actions["GoToExorLive"] = "go_to_exor_live";
    Actions["CancelExorLive"] = "cancel_exor_live";
    // PinAndBiometrics
    Actions["LoginForgotPin"] = "login_forgot_pin";
    Actions["LoginPinAndBiometricsSuccess"] = "login_pin_and_biometrics_success";
    // Motimate
    Actions["MotimateCreateUserStart"] = "motimate_create_user_start";
    Actions["MotimateCreateUserSubmit"] = "motimate_create_user_submit";
    Actions["MotimateCreateUserError"] = "motimate_create_user_error";
    Actions["MotimateCreateUserCompleted"] = "motimate_create_user_completed";
    Actions["MotimateCreateUserCanceled"] = "motimate_create_user_canceled";
    Actions["MotimateLinkClicked"] = "motimate_link_clicked";
    // Permissions-screens
    Actions["PermissionRequested"] = "permission_requested";
    Actions["PermissionsGranted"] = "permissions_granted";
    Actions["PermissionsMissing"] = "permissions_missing";
    Actions["PermissionsOverlay"] = "permissions_overlay";
    Actions["PermissionsRedirectToSettings"] = "permissions_open_settings";
    Actions["PermissionsRedirectToSettingsFailed"] = "permissions_open_settings_failed";
    // Profile-screens
    Actions["ProfileBiometrics"] = "profile_pin&biometrics";
    Actions["ProfileBiometricsChangePinCode"] = "profile_pin&biometrics_pincode";
    Actions["ProfileBiometricsSetBiometrics"] = "profile_pin&biometrics_biometrics_activate";
    Actions["ProfileBiometricsUnsetBiometrics"] = "profile_pin&biometrics_biometrics_deactivate";
    Actions["ProfileContact"] = "profile_contact";
    Actions["ProfileDetailsCountryCodePicked"] = "profile_personal_information_country_code_picked";
    Actions["ProfileDetailsCountryCodePressed"] = "profile_personal_information_country_code_pressed";
    Actions["ProfileInfoSaveError"] = "Profile_Save_Error";
    Actions["ProfileInfoSaved"] = "Saved_Personal_Info";
    Actions["ProfileOnboarding"] = "profile_onboarding";
    Actions["ProfilePartners"] = "home_insurance&discount";
    Actions["ProfilePaymentCard"] = "profile_payment_card";
    Actions["ProfilePermissions"] = "profile_permissions";
    Actions["ProfileReturn"] = "profile_return";
    Actions["ProfileSavedDetails"] = "profile_personal_information_saved";
    Actions["ProfileScreen"] = "profile_screen";
    Actions["ProfileVideoHelp"] = "profile_video_help";
    // Deprecated OS Version
    Actions["VersionDeprecationWarning"] = "version_deprecation_warning";
    Actions["VersionDeprecationWarningAction"] = "version_deprecation_warning_action";
    // Video-screens
    Actions["VideoAnsweredCall"] = "video_answered_call";
    Actions["VideoAnsweredCallOld"] = "Answered_Video_Call";
    Actions["VideoCallEnded"] = "video_call_ended";
    Actions["VideoConnected"] = "video_connected";
    Actions["VideoConnecting"] = "video_connecting";
    Actions["VideoDeclined"] = "video_declined";
    Actions["VideoDisconnected"] = "video_disconnected";
    Actions["VideoEndedConsultationOld"] = "Ended_Video_Consultation";
    Actions["VideoEnteredScreen"] = "video_entered_screen";
    Actions["VideoError"] = "video_error";
    Actions["VideoReceivedCall"] = "video_received_call";
    Actions["VideoRecievedCallOld"] = "Recieved_Video_Call";
    Actions["VideoSettingsChangeMicrophone"] = "video_settings_change_microphone";
    Actions["VideoSettingsFetchingActiveAudio"] = "video_settings_fetching_active_audio";
    Actions["VideoSettingsFlipCamera"] = "video_settings_flip_camera";
    Actions["VideoSettingsToggleMuteMicrophone"] = "video_settings_toggle_mute_microphone";
    Actions["VideoSummaryDisplayed"] = "video_displayed_summary";
    Actions["VideoTryingToConnect"] = "video_trying_to_connect";
    Actions["ApiError"] = "Api_Error";
    Actions["AppError"] = "app_error";
    // ---- Triage and add children
    // Triage
    Actions["BookInClinic"] = "book_in_clinic";
    Actions["ClickedChooseMedicalIssue"] = "clicked_choose_medical_issue";
    Actions["SelectMedicalIssue"] = "select_medical_issue";
    Actions["ChangeMedicalIssue"] = "change_medical_issue";
    Actions["ClickedReadMoreVideo"] = "clicked_read_more_video";
    Actions["ClickedClosedInfoCard"] = "clicked_closed_info_card";
    Actions["MedicalInfoCardTreatable"] = "medical_info_card_treatable";
    Actions["MedicalInfoCardClickedContinueVideo"] = "medical_info_card_clicked_continue_video";
    Actions["MedicalInfoCardClickedBookClinic"] = "medical_info_card_clicked_book_clinic";
    // Children
    Actions["ClickedAddChild"] = "clicked_add_child";
    Actions["AddedChild"] = "add_child_success";
    Actions["AddChildClosed"] = "add_child_closed";
    Actions["ErrorAddingChild"] = "add_child_error";
    Actions["SelectedChild"] = "select_child";
    Actions["SelectedSelf"] = "select_myself";
    Actions["DeletedChild"] = "deleted_child";
    // WEB
    // ----------------------------------------
    // Posthog
    Actions["ClickedPhysicalGuide"] = "clicked_physical_guide";
    Actions["CloseVideoModal"] = "close_video_modal";
    Actions["OpenVideoModal"] = "open_video_modal";
    Actions["FutureDateError"] = "web_booking_profilePersonalInformation_futureDateError";
    Actions["PastDateError"] = "web_booking_profilePersonalInformation_pastDateError";
    Actions["PhoneVerificationError"] = "phoneVerificationError";
    Actions["PhoneVerificationSuccess"] = "phoneVerificationSuccess";
    Actions["PhoneVerificationSupport"] = "phoneVerificationSupport";
    // Choose Doctor V2
    Actions["ChooseDoctorFilterOpened"] = "choose_doctor_filter_opened";
    Actions["ChooseDoctorFilterSelectAll"] = "choose_doctor_filter_select_all";
    Actions["ChooseDoctorFilterCompleted"] = "choose_doctor_filter_completed";
    Actions["ChooseDoctorSearch"] = "choose_doctor_search";
    Actions["ChooseDoctorSelectPractitioner"] = "choose_doctor_select_practitioner";
    Actions["ChooseDoctorSelectDifferentClinic"] = "choose_doctor_select_different_clinic";
})(Actions || (exports.Actions = Actions = {}));
